import { AuthVerifierContext } from "../AuthVerifierProvider";
import type { AuthVerifierContextType } from "../AuthVerifierProvider";
import useDefinedContext from "hooks/useDefinedContext";

function useAuthVerifier(): AuthVerifierContextType {
  return useDefinedContext(AuthVerifierContext);
}

export default useAuthVerifier;
